import { StoreItemPath } from 'app/types-shared';
import { getEntityTypeFromPath } from 'app/infrastructure/store/entity';

/**
 * Because data can be structured differently from how components are placed in their hierarchy, e.g. with intermediate non-key components,
 * it is necessary to combine the data path with the key values in the component hierarchy to produce the actual store path.
 *
 * @param entityTypePath The data path describes the keys that an object needs and the order in which they are expected.
 * @param componentPath The component path describes the physical location in the component hierarchy, with key values.
 */
export const getStorePath = (
  entityTypePath: string[], 
  componentPath: StoreItemPath[], 
  allowUnmatchedIds: boolean = false): StoreItemPath[] => {

    if (!entityTypePath) {
      return undefined;
    }

    const entityType = getEntityTypeFromPath(entityTypePath);

    // A component will always have a context within the form.
    const path = componentPath.slice().reverse();
    const parentPath = [];
    
    // The data path must be matched with concrete ids from the current component path.
    entityTypePath.slice().map((pathType, index) => {

      const pathIndex = path.findIndex(c => Object.keys(c)[0].toLowerCase() === pathType.toLowerCase());
      // The first match, if found, is used as the key for that level.
      if (pathIndex > -1) {
        parentPath.push(path[pathIndex]);
      } 
      // The only entity that we allow no match for is the current, because this is possible to calculate when adding children.
      // All other unmatched items indicate misconfiguration.
      else if (!allowUnmatchedIds && pathType !== entityType) {
        throw new Error(
          `Could not find a match for the data path item ${entityType} 
          in component path ${JSON.stringify(componentPath)}. Check configuration.`
        );
      }
    });
    
    return parentPath;
};
